import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MembershipPlansComponent } from "src/app/admin-panel/components/business/membership-plans/membership-plans.component";
import { PaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/payment-processors.component";
import { PaymentsComponent } from "src/app/admin-panel/components/business/payments/payments.component";
import { AppUsersComponent } from "src/app/admin-panel/components/members/app-users/app-users.component";
import { MemberCompaniesComponent } from "src/app/admin-panel/components/members/member-companies/member-companies.component";
import { AdministratorComponent } from "src/app/admin-panel/components/system-profiles/administrator/administrator.component";
import { MyProfileComponent } from "src/app/admin-panel/components/system-profiles/my-profile/my-profile.component";
import { TechSupportComponent } from "src/app/admin-panel/components/system-profiles/tech-support/tech-support.component";
import { AuthGuard } from "src/app/guard/guard.component";
import { PageNotFoundComponent } from "src/app/share-modul/components/page-not-found/page-not-found.component";



const routes: Routes = [


    { path: 'my-profile', component: MyProfileComponent, canActivate: [AuthGuard] },
    { path: 'administrators', component: AdministratorComponent, canActivate: [AuthGuard]  },
    { path: 'tech-support', component: TechSupportComponent,canActivate: [AuthGuard]   },
    { path: 'membership-plans', component: MembershipPlansComponent,  canActivate: [AuthGuard] },
    { path: 'payment-processors', component: PaymentProcessorsComponent, canActivate: [AuthGuard]  },
    { path: 'payments',component:PaymentsComponent,canActivate: [AuthGuard] },
    { path: 'member-companies',component:MemberCompaniesComponent,canActivate: [AuthGuard] },
    { path: 'app-users',component:AppUsersComponent,canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AdminRoutingModule { }
